import { TabOptionType } from "../components/reusable-ui/material-ui-comp/custom-tab-switch";
import { isMobileDevice } from "../helpers/device-info-helper";
import { SubTabsDataType } from "../layouts/header";
import { USER_ROLES } from "./constants";
import { GA_EVENTS } from "./ga-constants";
import { ALL_FEATURE_TYPES_MAP, Licences } from "./user-features-constants";

export const ONLINE_ORDER_RECON_INTRO_STEPS = [
  {
    icon: "ic-document",
    text: `Upload Payout report of your online partner by clicking on Upload new file Button.`,
  },
  {
    icon: "ic-select-options",
    text: `Once the file is uploaded, select branch, online partner and date range from this page.`,
  },
  {
    icon: "ic-results",
    text: `Click on apply and you will see details of your report. you can scroll down to see order-wise reports.`,
  },
];

export const RECON_ORDER_TYPES = [
  {
    type: "matched",
    text: "Matched Orders",
  },
  {
    type: "unmatched",
    text: "Unmatched Orders",
  },
  {
    type: "not found",
    text: "Orders Not Found",
  },
];

export const UPLOAD_STATUS_TYPES: any = {
  processing: {
    type: "processing",
    label: "Processing File Data",
  },
  failed: {
    type: "failed",
    label: "Upload Failed",
  },
  processed: {
    type: "processed",
    label: "Processed",
  },
};

export const FULFILLMENT_STATUS_TYPES = {
  Processed: "Processed",
  Dispatched: "Dispatched",
  Delivered: "Delivered",
  Created: "Created",
  Accepted: "Accepted",
};

export const ORDERWISE_PAYOUT_COLUMNS_VISIBILITY: any = {
  [RECON_ORDER_TYPES[1].type]: {
    ORDER_NOT_FOUND_ON: false,
  },
  [RECON_ORDER_TYPES[2].type]: {
    CUSTOMER_PAYABLE_RISTA: false,
    AGGREGATOR_PLATFORM_FEE_RISTA: false,
    FINAL_PAYOUT_RISTA: false,
    difference: false,
  },
};

export const EMAIL_IDS_ALLOWED_FOR_RECON_ENGINE = [
  "devam.gupta@dotpe.in",
  "deepak.yadav@dotpe.in",
  "nitin.mishra@dotpe.in",
  "amit.jha@dotpe.in",
  "luvjyot.kaur@dotpe.in",
  "ritik.khatri@dotpe.in"
];

export const ACCOUNTING_TABS_MAP: Record<string, SubTabsDataType> = {
  online_order_reconciliation: {
    tabId: "online_order_reconciliation",
    text: "Online Order Reconciliation",
    emailIds: [], //EMAIL_IDS_ALLOWED_FOR_RECON_ENGINE,
    conditionsCheck: { licence: [], role: [USER_ROLES.admin], ga_event: GA_EVENTS.RECON_ENGINE_REQUEST }, //show this route in sidebar, but when opening page, show "you do not have access to this feature"
    businessNames: [],
    isNew: true,
  },
  cash_management: {
    tabId: "cash_management",
    text: "Cash Management",
    feature: ALL_FEATURE_TYPES_MAP.DAILY_CLOSING,
  },
  cashier_settlement: {
    tabId: "cashier_settlement",
    text: "Cashier Settlement",
    feature: ALL_FEATURE_TYPES_MAP.DAILY_CLOSING,
  },
  pnl_statement: {
    tabId: "pnl_statement",
    text: "P&L Statement",
  },
  xml_generator: {
    tabId: "xml-generator",
    text: "XML Generator",
    feature: [
      ALL_FEATURE_TYPES_MAP.ALLOW_DOWNLOAD_XML_LEDGER_REPORT,
      ALL_FEATURE_TYPES_MAP.ALLOW_EDIT_XML_LEDGER_MAPPING,
    ],
    isShow: !isMobileDevice(),
  },
  account_summary: {
    tabId: "account-summary",
    text: "Account Summary",
    feature: [
      ALL_FEATURE_TYPES_MAP.SALES_BY_DAY,
      ALL_FEATURE_TYPES_MAP.PAYMENTS_BY_DAYS,
      ALL_FEATURE_TYPES_MAP.BALANCE_BY_DAYS,
    ],
  },
  sales_audit: {
    tabId: "sales-audit",
    text: "Sales Audit",
    permission: [USER_ROLES.admin],
  },
};

export const PNL_STATEMENT_INTRO_STEPS = [
  {
    icon: "ic-calendar-blue",
    text: `Select the date range for the P&L.`,
  },
  {
    icon: "ic-branches-blue",
    text: `Select the branches for which the P&L report is needed.`,
  },
  {
    icon: "ic-select-options active",
    text: `Click on View P&L Statement to view the report.`,
  },
  {
    icon: "ic-download-blue active",
    text: `Click on Download to get the P&L Statement in a CSV file.`,
  },
];

export const XML_REPORT_TYPES_LIST: TabOptionType[] = [
  {
    label: "Sales",
    value: "Sales",
  },
  {
    label: "Purchase",
    value: "Purchase",
  },
  // {
  //   label: "Master",
  //   value: "master",
  // },
];